import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import logoimg from '../../assets/MK1.3.png';
import senddata from "../../Data/data.js";

function Student() {
    const location = useLocation();
    var student = location.state;

    const [enableEdit,setEnableEdit] = useState(false);
    const [enableEdit1,setEnableEdit1] = useState(false);
    const [enableEdit2,setEnableEdit2] = useState(false);

    const [firstName,setFirstName] = useState(student.FirstName);
    const [lastName,setLastName] = useState(student.LastName);
    const [email,setEmail] = useState(student.email);
    const [mobile,setMobile] = useState(student.mobile);
    const [parentPhoneNumber,setParentPhoneNumber] = useState(student.parentPhoneNumber);
    const [password,setPassword] = useState(student.password);
    const [level,setLevel] = useState(student.level);
    const [departement,setDepartement] = useState(student.departement);
    const [myCourses,setMyCourses] = useState(student.myCourses||[]);

    const [selectlevel,setSelectlevel] = useState(student.level+"-"+student.departement);

    const [myCoursesId,setMyCoursesId] = useState([]);

    const [allCourses,setAllCourses] = useState([]);

    const [score,setScore] = useState("");

    const [allVideosTime,setAllVideosTime] = useState([]);

    const [allExams,setAllExams] = useState([]);



    useEffect(()=>{
        if(selectlevel=="six-pri"){
          setLevel("six")
          setDepartement("pri");
        } else if(selectlevel=="one-pre"){
          setLevel("one")
          setDepartement("pre");
        } if(selectlevel=="two-pre"){
          setLevel("two")
          setDepartement("pre");
        } if(selectlevel=="three-pre"){
          setLevel("three")
          setDepartement("pre");
        } if(selectlevel=="one-sec"){
          setLevel("one")
          setDepartement("sec");
        } if(selectlevel=="two-sec"){
            setLevel("two")
            setDepartement("sec");
        } if(selectlevel=="three-sec"){
            setLevel("three")
            setDepartement("sec");
        }
      },[selectlevel])

      useEffect(()=>{
        getAllcourses();
        getScore();
        getVideosTime();
        getExamResults();
    },[]);

    useEffect(()=>{
        const ids= myCourses.map(course => course._id);
        setMyCoursesId(ids);
    },[setMyCourses]);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = ''; 
        };
    
        window.addEventListener('beforeunload', handleBeforeUnload);
    
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    const saveInfo = ()=>{
        const data ={
            ...student,
            FirstName:firstName,LastName:lastName,email,mobile,parentPhoneNumber,password,level,departement
        }
        senddata(`teacher/editstudent/${student._id}`,data, "PATCH").then((res) => {
            if (res.status !== 200) {
                alert(res.data);
            } else {
                alert('ـم تعديل الطالب بنجاح ');
                setEnableEdit(!enableEdit)
            }
        });
    }

    const savePassword = ()=>{
        const data = {
            mobile: mobile,
            new_password: password
          }
          
        senddata(`student/new_password_mobile`,data, "Post").then((res) => {
            if (res.status !== 200) {
                alert(res.data);
            } else {
                alert('ـم تعديل الباسوورد بنجاح ');
                setEnableEdit2(!enableEdit2)
            }
        });
    }

    const getAllcourses = ()=>{
        senddata(`course/getmycourses`,{}, "GET").then((res) => {
            if (res.status !== 200) {
                alert("تأكد من الاتصال بالانترنت");
            } else {
                console.log(res.data);
                setAllCourses(res.data);
            }
        });
    }

    const deleteCourse = (course)=>{
        const id = course._id;
        const userResponse = prompt(`اكتب Ok لتأكيد حذف الكورس عند الطالب `);
        if(userResponse?.trim() =="ok" ){
            const newMyCourses = myCourses?.filter(course => course._id !== id)
            setMyCourses(prevCourses => prevCourses.filter(course => course._id !== id));
            setAllCourses(prevAllCourses => [...prevAllCourses , course ]);
            const data ={...student,myCourses:newMyCourses}
            console.log("data",data);
            senddata(`teacher/editstudent/${student._id}`,data, "PATCH").then((res) => {
                if (res.status !== 200) {
                    alert(res.data);
                } else {
                    alert('ـم تعديل الطالب بنجاح ');
                }
            });
            
        }else{
            alert("لم يتم حذف الكورس")
        }
        
    }

    const addCourse = (course)=>{
        const id =course._id
        const foundCourse = myCourses?.find(course => course._id == id);
        if(foundCourse) {
            alert('الكورس مضاف بالفعل ');
            return;
        }
        const userResponse = prompt(`اكتب Ok لتأكيد اضافة الكورس عند الطالب `);
        if(userResponse?.trim() =="ok" ){
            const newCourse = {
                _id:course._id,
                title:course.title,
                teacher:course.teacher,
                subject:course.subject,
                price:course.price,
                level:course.level,
                departement:course.departement,
                UniversityName:"",
                collegeName:""
            }
            const newMyCourses = [...myCourses, newCourse];
            console.log(newMyCourses);
            setMyCourses(prevCourses => [...prevCourses, newCourse] );
            setAllCourses(prevAllCourses => prevAllCourses.filter(course => course._id !== id));
            const data ={...student , myCourses:newMyCourses}
            console.log("data",data);
            senddata(`teacher/editstudent/${student._id}`,data, "PATCH").then((res) => {
                if (res.status !== 200) {
                    alert(res.data);
                } else {
                    alert('تم تعديل الطالب بنجاح ');
                }
            });
        }else{
            alert("لم يتم حذف الكورس")
        }
        
    }


    const getScore = ()=>{
        senddata(`score/get_student_score_for_teacher/${student._id}`,{}, "GET").then((res) => {
            if (res.status !== 200) {
                alert("تأكد من الاتصال بالانترنت");
            } else {
                setScore(res.data.score);
            } 
        });
    }

    const getVideosTime = ()=>{
        senddata(`tracktime/get_all_time_for_student/${student._id}`,{}, "GET").then((res) => {
            if (res.status !== 200) {
                alert("تأكد من الاتصال بالانترنت");
            } else {
                setAllVideosTime(res.data);
            } 
        });
    }

    const getExamResults = ()=>{
        senddata(`student/exam/get_all_studentresults_for_teacher/${student._id}`,{}, "GET").then((res) => {
            if (res.status !== 200) {
                alert("تأكد من الاتصال بالانترنت");
            } else {
                console.log("res",res.data);
                setAllExams(res.data);
            } 
        });
    }



    console.log(student);
    return (
        <div className=' bg-[#1A1A4C] text-white flex flex-col min-h-screen text-base font-semibold pb-[600px] '>
            {/* headers */}
            <div className='headers '>
                <img src={logoimg} className='w-[70px] rounded-full mx-7 mt-2 ml-auto'/>
            </div>
            {/* details */}
            <div className='flex flex-col items-center'>
                <h2 className='border-b-2 border-[#e9ad03]'>تفاصيل الطالب</h2>
                <div className='flex flex-row justify-between w-[60%] mt-6'>
                    {enableEdit?<input className=' bg-transparent border-b-2 border-[#e9ad03] focus:outline-none' value={firstName} onChange={(e)=>{setFirstName(e.target.value)}} />:<p>{firstName}</p>}
                    <p>: الاسم الأول</p>
                </div>
                <div className='flex flex-row justify-between w-[60%] mt-2'>
                    {enableEdit?<input className=' bg-transparent border-b-2 border-[#e9ad03] focus:outline-none' value={lastName} onChange={(e)=>{setLastName(e.target.value)}} />:<p>{lastName}</p>}
                    <p>: اسم العاائلة</p>
                </div>
                <div className='flex flex-row justify-between w-[60%] mt-2'>
                    {enableEdit?<input className=' bg-transparent border-b-2 border-[#e9ad03] focus:outline-none' value={email} onChange={(e)=>{setEmail(e.target.value)}} />:<p>{email}</p>}
                    <p>: اسم المستخدم</p>
                </div>
                <div className='flex flex-row justify-between w-[60%] mt-2'>
                    {enableEdit?<input className=' bg-transparent border-b-2 border-[#e9ad03] focus:outline-none' value={mobile} onChange={(e)=>{setMobile(e.target.value)}} />:<p>{mobile}</p>}
                    <p>: رقم الهاتف</p>
                </div>
                <div className='flex flex-row justify-between w-[60%] mt-2'>
                    {enableEdit?<input className=' bg-transparent border-b-2 border-[#e9ad03] focus:outline-none' value={parentPhoneNumber} onChange={(e)=>{setParentPhoneNumber(e.target.value)}} />:<p>{parentPhoneNumber}</p>}
                    <p>: رقم ولي الأمر</p>
                </div>
                <div className='flex flex-row justify-between w-[60%] mt-2'>
                    {enableEdit2?<input className=' bg-transparent border-b-2 border-[#e9ad03] focus:outline-none' value={password} onChange={(e)=>{setPassword(e.target.value)}} />:<p>{password}</p>}
                    <p>: الباسوورد</p>
                </div>
                <div className='flex flex-row justify-between w-[60%] mt-2'>
                    <p>{score}</p>
                    <p>: score</p>
                </div>
                <div className='flex flex-row justify-between w-[60%] mt-2'>
                    {enableEdit?
                    <select value={selectlevel} onChange={(event)=>{setSelectlevel(event.target.value);}} className="bg-transparent border-b-2 border-[#e9ad03] focus:outline-none ">
                        <option value="six-pri" className=' text-black'>ستة اعدادي</option>
                        <option value="one-pre" className=' text-black'>اولي اعدادي</option>
                        <option value="two-pre" className=' text-black'>تانية اعدادي</option>
                        <option value="three-pre" className=' text-black'>تالتة اعدادي</option>
                        <option value="one-sec" className=' text-black'>اولي ثانوي</option>
                        <option value="two-sec" className=' text-black'>تانية ثانوي</option>
                        <option value="three-sec" className=' text-black'>تالتة ثانوي</option>
                    </select>
                    :<p>{level}</p>}
                    <p>: السنة</p>
                </div>
                <div className='flex flex-row justify-between w-[60%] mt-2'>
                    <p>{departement}</p>
                    <p>: المرحلة</p>
                </div>
            </div>
            <div className='grid grid-cols-2 gap-2 w-[70%] ml-auto mr-auto mt-10'>
                {enableEdit?<p onClick={saveInfo} className='px-7 py-1 bg-[#e9ad03] w-fit rounded-full cursor-pointer mr-auto' > حفظ</p>:<p></p>}
                <p onClick={()=>{setEnableEdit(!enableEdit)}} className='px-7 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer ml-auto'>{enableEdit?"عدم التعديل":"تعديل "}</p> 
            </div>
            <div className='grid grid-cols-2 gap-2 w-[70%] ml-auto mr-auto mt-5'>
                {enableEdit2?<p onClick={savePassword} className='px-7 py-1 bg-[#e9ad03] w-fit rounded-full cursor-pointer mr-auto' > حفظ</p>:<p></p>}
                <p onClick={()=>{setEnableEdit2(!enableEdit2)}} className='px-6 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer ml-auto'>{enableEdit2?"عدم التعديل":"تعديل الباسوورد"}</p> 
            </div>
            <div className='flex flex-col items-center mt-8'>
                <h2 className='border-b-2 border-[#e9ad03]'>كورسات الطالب </h2>
            </div>

            {myCourses.length &&<div className='grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 mt-8 gap-4 w-[90%] ml-[5%] '>
            {
              myCourses?.map((course,key)=>{
                return(
                  <div className='mb-10 border-2 border-[#e9ad03] rounded-xl p-2 '>
                    <div className='p-3'>
                      <p className=' text-center text-[#e9ad03]'>{ key+1 } </p>
                      <p className=' text-center text-[#e9ad03]'>{course.title} </p>
                      <p className=' text-center text-[#e9ad03]'>{course.subject} </p>
                      <p className=' text-center text-[#e9ad03]'>{course.level} </p>
                      <div className='flex justify-between items-center'>
                        <div className='flex '>
                          <p onClick={()=>{deleteCourse(course)}} className='mr-4 text-lg cursor-pointer'>🗑️</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            }
            </div>}

            <div className='flex flex-col items-center mt-8'>
                <h2 className='border-b-2 border-[#e9ad03]'>اضافة كورسات الطالب </h2>
            </div>
            <div className='flex flex-col items-end mt-8 w-full '>
                <p onClick={()=>{setEnableEdit1(!enableEdit1)}} className='px-7 py-1 bg-[#da0000] w-fit rounded-full cursor-pointer mx-[10%] '>{enableEdit1?"اخفاء":"اضافة الكورسات "}</p> 
            </div>
            <div className='grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 mt-8 gap-4 w-[90%] ml-[5%] '>
            {
              enableEdit1 && allCourses?.map((course,key)=>{
                const exist = myCoursesId.find((corseid)=> corseid==course._id )
                if (exist) return ;
                return(
                  <div className='mb-10 border-2 border-[#e9ad03] rounded-xl  '>
                    <div className='p-3'>
                      <p className=' text-center text-[#e9ad03]'>{ key+1 } </p>
                      <p className=' text-center text-[#e9ad03]'>{course.title} </p>
                      <p className=' text-center text-[#e9ad03]'>{course.subject} </p>
                      <p className=' text-center text-[#e9ad03]'>{course.level} </p>
                      <div className='flex justify-between items-center'>
                        <div className='flex '>
                        {enableEdit1?<p onClick={()=>{addCourse(course)}} className='px-3  bg-[#e9ad03] w-fit rounded-full cursor-pointer mr-auto mt-2' >  اضافة</p>:<p></p>}
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            }
            </div>

            {/* video watch */}

            <div className='flex flex-col items-center mt-8'>
                <h2 className='border-b-2 border-[#e9ad03]'>  مشاهدة الفيديوهات </h2>
            </div>

            {
            allVideosTime.length &&(
                <div className='w-full overflow-x-auto scrollbar-hidden px-6 mt-8 '>
                    <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' > 
                        <div className='text-base w-[250px] text-center'>اسم الفيديو </div>
                        <div className='text-base w-[200px] text-center'>وقت المشاهدة </div>                        </div>
                    {
                    allVideosTime.length && allVideosTime?.map((VideoTime)=>{
                        return(
                            <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' key={VideoTime._id}> 
                            <div className='text-base w-[250px] text-center'>{VideoTime.videoname}</div>
                            <div dir='rtl' className='text-base w-[200px] text-center'>{VideoTime.timewatched} دقيقة</div>                                </div>
                        )
                        })
                    }                    
                </div>
                )
            }

            {/* exam results */}


            <div className='flex flex-col items-center mt-16'>
                <h2 className='border-b-2 border-[#e9ad03]'>  درجات الامتحانات   </h2>
            </div>

            {
            allExams.length &&(
                <div className='w-full overflow-x-auto scrollbar-hidden px-6 mt-8 '>
                    <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' > 
                        <div className='text-base w-[250px] text-center'>اسم الامتحان </div>
                        <div className='text-base w-[150px] text-center'>الدرجة </div>
                        <div className='text-base w-[150px] text-center'>النسبة </div>
                        <div className='text-base w-[150px] text-center'>الاجابات الصحيحة </div>
                        <div className='text-base w-[150px] text-center'>الاجابات الخاطئة </div>
                    </div>
                    {
                    allExams.length && allExams?.map((exam)=>{
                        return(
                            <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' key={exam._id}> 
                                <div className='text-base w-[250px] text-center'>{exam.examname=="single_exam"?"امتحان عام":exam.examname}</div>
                                <div dir='rtl' className='text-base w-[150px] text-center'>{exam.result} / {exam.totalmark} </div>   
                                <div dir='rtl' className='text-base w-[150px] text-center'>{ ((exam.result / exam.totalmark)*100).toFixed(2)  } % </div>   
                                <div dir='rtl' className='text-base w-[150px] text-center'>{exam.correctanswer} </div>   
                                <div dir='rtl' className='text-base w-[150px] text-center'>{exam.wronganswer  } </div>   
                            </div>
                        )
                        })
                    }                    
                </div>
                )
            }            


        
        </div>
    )
}

export default Student
